import { Skeleton } from '@mui/material'
import clsx from 'clsx'

import { ApiAssetWithOrderAlert } from '@/api/rtk-api'
import { Icon } from '@/components/core-v2/'

import classes from './assets-list.module.scss'
import { useOrdersFiltersContext } from './orders-filter-context'

export interface AssetsListProps {
  data: ApiAssetWithOrderAlert[]
  isLoading: boolean
}

const Item = () => (
  <div className={classes.item}>
    <Skeleton className="mb-1" height="17px" width="200px" />
    <Skeleton height="17px" width="100px" />
  </div>
)

const Loading = () => (
  <>
    <Item />
    <Item />
    <Item />
    <Item />
    <Item />
    <Item />
    <Item />
    <Item />
    <Item />
    <Item />
    <Item />
    <Item />
  </>
)

export const AssetsList = ({ data, isLoading }: AssetsListProps) => {
  const { asset, setAsset } = useOrdersFiltersContext()
  if (isLoading) return <Loading />

  return (
    <ul>
      {!data || data.length === 0 ? (
        <>No assets matched the search criteria</>
      ) : (
        data.map(item => (
          <li key={item.asset.assetId}>
            <button
              className={clsx(classes.item, {
                [classes.selected]: asset?.assetId === item.asset.assetId
              })}
              type="button"
              onClick={() => setAsset(item.asset)}
            >
              {item.hasLateOrderConfirmations && (
                <div className={classes.late}>
                  <Icon name="bell" size="default" />
                  <strong>LATE CONFIRMATIONS</strong>
                </div>
              )}
              <div className={classes.assetName}>{item.asset.name}</div>
              <div className={classes.assetId}>{(item.asset as any).isinCode}</div>
            </button>
          </li>
        ))
      )}
    </ul>
  )
}
